import Button from '@brainpool/components/atoms/Button/Button';
import { IconPosition } from '@brainpool/components/types/Button';
import Stack from '@mui/material/Stack';

export interface ModalButtonsProps {
  onCancel: () => void;
  onConfirm: () => void;
  isValid?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

export function ModalButtons({
  onCancel,
  onConfirm,
  isValid = true,
  confirmLabel,
  cancelLabel,
  isLoading,
}: ModalButtonsProps) {
  const buttonStyle = {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '1rem 1rem 2rem !important',
  };

  return (
    <Stack direction="row">
      <Button
        label={cancelLabel || 'Cancel'}
        variant="contained"
        onClick={onCancel}
        sx={buttonStyle}
        color="info"
      />
      <Button
        label={confirmLabel || 'Confirm'}
        variant="contained"
        onClick={onConfirm}
        disabled={!isValid || isLoading}
        sx={buttonStyle}
        isLoading={isLoading}
        iconPosition={IconPosition.After}
      />
    </Stack>
  );
}
export default ModalButtons;
